// extracted by mini-css-extract-plugin
module.exports = {"section":"our-team-module--section--1Hb9v"};